/*
 * File: 会议信息卡片
 * File Created: 2021-05-12 7:24:55 pm
 * Author: huangxl (huangxl20@meicloud.com)
 * -----
 * Last Modified: 2021-06-12 3:42:35 pm
 * Modified By: huangxl (huangxl20@meicloud.com)
 */

<template>
  <div
    :class="{
      'meeting-info': true,
      'meeting-info-canceled': meetingStatus === 6 && endType === 3
    }">
    <div class="title">{{ topicOfLang }}</div>
    <div
      :class="meetingStatusTextClass">
      {{ meetingStatusDesc }}
    </div>
    <div class="date">
      <div class="time">
        <span class="h">
          {{ startHour }}
        </span>
        <span class="ymd">
          {{ startTime && $d(+startTime, 'short') }}
        </span>
      </div>
      <div class="line" style="margin-left: 8px;"></div>
      <div class="center">
        <span class="spacing">
          {{ meetingDuration }}
        </span>
        <span class="text">({{ getTimeZoneText() }})</span>
      </div>
      <div class="line" style="margin-right: 8px;"></div>
      <div class="time">
        <span class="h">
          {{ endHour }}
        </span>
        <span class="ymd">
          {{ endTime && $d(+endTime, 'short') }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'meeting-info',
  props: {
    // 1-已建立，2-入场中，3-已开始，4-清场中，5-已结束，6-已取消；
    meetingStatus: Number,
    topic: {
      type: String,
      default: ''
    },
    topicI18n: String,
    startTime: String,
    endTime: String,
    // 1. 自动结束 2.手动结束 3.取消
    endType: Number,
  },
  computed: {
    startHour() {
      if (this.startTime) {
        const date = new Date(+this.startTime);
        const h = date.getHours(),
              m = date.getMinutes();
        return `${ h > 9 ? h : '0' + h }:${ m > 9 ? m : '0' + m }`
      }
      return ''
    },
    endHour() {
      if (this.endTime) {
        const date = new Date(+this.endTime);
        const h = date.getHours(),
              m = date.getMinutes();
        return `${ h > 9 ? h : '0' + h }:${ m > 9 ? m : '0' + m }`
      }
      return ''
    },
    meetingDuration() {
      if (this.startTime && this.endTime) {
        const duration = +this.endTime - +this.startTime
        console.log('hourDuration', duration)
        const hourDuration = duration / (1000 * 60 * 60)
        console.log('hourDuration', hourDuration)
        return hourDuration < 1
          ? `${ hourDuration * 60 }${ this.$t('common.minutes') }`
          : (hourDuration % 1 === 0
            ? `${ hourDuration }${ this.$t('common.hour') }`
            : `${ Math.floor(hourDuration) }${ this.$t('common.hour') }${ Math.round((hourDuration % 1)* 60) }${ this.$t('common.minutes') }`)
      }
      return 0
    },
    meetingStatusDesc() {
      let text = ''
      if (!this.meetingStatus) {
        return text
      }
      switch (this.meetingStatus) {
        case 1:
        case 2:
          text = this.$t('common.readyToStart')
          break;

        case 3:
          text = this.$t('common.ing')
          break;

        case 4:
          text = this.$t('common.finishedAuto')
          break;
        case 5:
          if(this.endType === 1) {
            text = this.$t('common.finishedAuto')
          } else {
            text = this.$t('common.finishedByPresenter')
          }
          break;
        case 6:
          if(this.endType === 3) {
            text = ''
          } else {
            text = this.$t('common.finishedByPresenter')
          }
          break;

        default:
          text = this.$t('common.readyToStart')
          break;
      }
      return text
    },
    meetingStatusTextClass() {
      let textClass = ['status']
      switch (this.meetingStatus) {
        case 1:
        case 2:
          textClass.push('orange')
          break;

        case 3:
          textClass.push('blue')
          break;

        case 4:
        case 5:
          textClass.push('gray')
          break;
        case 6:
          if(this.endType !== 3){
            textClass.push('gray')
          }
          break;
        default:
          textClass.push('orange')
          break;
      }
      return textClass
    },
    // 多语言匹配标题
    topicOfLang(){
      const lang = this.$i18n.locale
      // zh-CN  en-US  ja-JP
      if(!this.topicI18n) return this.topic
      const {topicZh, topicEn, topicJa} = JSON.parse(this.topicI18n)
      console.log(lang, JSON.parse(this.topicI18n))
      if(topicZh && (
        lang === 'zh-CN'
        || (lang === 'en-US' && !topicEn)
        || (lang === 'ja-JP' && !topicEn && !topicJa)
      )) {
        console.log('展示中文')
        return topicZh
      } else if(topicEn && (
        lang === 'en-US'
        || (lang === 'zh-CN' && !topicZh)
        || (lang === 'ja-JP' && !topicJa)
      )) {
        console.log('展示英文')
        return topicEn
      } else if(topicJa) {
        console.log('展示日文')
        return topicJa
      } else {
        return this.topic
      }
    }
  },
  methods: {
    // 获取当地GMT时区
    getTimeZoneText() {
      const dateSting = new Date().toString()
      const timeZoneText = dateSting.match(/GMT[+|-]\d*/)[0]
      let strArr = timeZoneText.split('')
      strArr.splice(strArr.length - 2, 0, ':')
      return strArr.join('')
    },
  }
}
</script>

<style lang='less' scoped>
  @cancelColor: #787878;
  @cancelColor2: #A3A3A3;
  @cancelColor3: #B9B9B9;
  @cancelColor4: #BCBCBC;
  .meeting-info {
    width: 100%;
    height: 205px;
    background-color: #fff;
    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.05);
    border-radius: 8px;
    overflow: hidden;
    margin-top: 15px;
    background-image: url('~@/assets/images/icons/meeting-bg.png');
    background-repeat: no-repeat;
    background-position: center bottom;
    background-size: 35%;
    .title {
      font-size: 18px;
      font-weight: bold;
      text-align: center;
      margin-top: 30px;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      padding: 0 12px;
      line-height: 24px;
      min-height: 24px;
      text-overflow: ellipsis;
    }
    .status {
      font-size: 12px;
      text-align: center;
      margin: 20px 0 5px 0;
    }
    .blue {
      color: #3696FF;
    }
    .orange {
      color: #FFCE50;
    }
    .gray {
      color: #BCBCBC;
    }
    .date {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      padding: 0 30px;
      .time {
        display: flex;
        flex-direction: column;
        align-items: center;
        flex-shrink: 0;
        .h {
          font-size: 28px;
          font-weight: bold;
          margin-bottom: 6px;
        }
        .ymd {
          font-size: 12px;
        }
      }
      .line {
        width: 15px;
        height: 1px;
        background-color: #E2E2E2;
        margin-top: 17px;
      }
      .center {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-top: 6px;
        flex-shrink: 0;
        .spacing {
          color: #545454;
          background-color: #EEEEEE;
          border-radius: 4px;
          line-height: 20px;
          padding: 1px 6px;
          font-size: 14px;
          margin-bottom: 12px;
        }
        .text {
          color: #BCBCBC;
          font-size: 12px;
        }
      }
    }
  }
  .meeting-info-canceled {
    background-image: url('~@/assets/images/icons/meeting-bg-cancel.png') !important;
    .title {
      color: @cancelColor;
    }
    .date {
      .time {
        .h {
          color: @cancelColor;
        }
        .ymd {
          color: @cancelColor3;
        }
      }
      .center {
        .spacing {
          color: @cancelColor2;
        }
        .text {
          color: @cancelColor4;
        }
      }
    }

  }
</style>
